import Vue from 'vue'
import App from './App.vue'
import './assets/fonts/fonts.css'
// import px2rem from './utils/px2rem'
// px2rem()
Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
